import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService, EventBusService } from '../../services';
import messages from '../../utility/messages';
import constants from '../../utility/constants';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-returning-user-reset-password',
  templateUrl: './returning-user-reset-password.component.html',
  styleUrls: ['./returning-user-reset-password.component.css'],
})
export class ReturningUserResetPasswordComponent implements OnInit {
  forgotForm: FormGroup;
  loading: boolean = false;
  emailHign: any = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}';
  error: String = '';
  private subscriptions: Array<Subscription> = [];
  constructor(
    public modalRef: BsModalRef,
    public formBuilder: FormBuilder,
    public authenticationService: AuthenticationService,
    public ebs: EventBusService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.forgotForm = this.formBuilder.group({
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.emailHign),
        ])
      ),
    });
  }
  openModalFile(modalName: String) {
    this.ebs.notification.emit(modalName);
  }
  hideAndReset() {
    this.modalRef.hide();
    this.forgotForm.reset();
  }
  onForgotSubmit() {
    this.loading = true;
    const generatePassword = this.authenticationService
      .generatePasswordLink(this.forgotForm.get('email').value)
      .subscribe(
        () => {
          this.loading = false;
          this.toastr.success(
            messages.forgetPassword.emailSent,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.hideAndReset();
        },
        (err) => {
          this.loading = false;
          this.error = err;
        }
      );
      this.subscriptions.push(generatePassword);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
